import { SET_VERIFIED_USER } from "../actions/constants";

const defaultState = {
  verifiedList: [],
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case SET_VERIFIED_USER:
      return { ...state, verifiedList: action.payload };
    default:
      return state;
  }
};
